import axios from "../lib/axios";

export const getTemplateDropsDowns = async () => {
  try {
    const response = await axios.get("/templates/dropdown-options");
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch dropdown options"
    );
  }
};

export const getTemplatesDetails = async (id) => {
  try {
    const response = await axios.get(`/templates/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch template details"
    );
  }
};

export const createTemplate = async (payload) => {
  try {
    const response = await axios.post(`/templates/create`, payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create template"
    );
  }
};

export const getTemplate = async () => {
  try {
    const response = await axios.get(`/templates`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch templates"
    );
  }
};

// UPDATE TEMPLATE
export const updateTemplate = async (id, payload) => {
  try {
    const response = await axios.put(`/templates/${id}`, payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update template"
    );
  }
};

// DELETE TEMPLATE
export const deleteTemplate = async (id) => {
  try {
    const response = await axios.delete(`/templates/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to delete template"
    );
  }
};
